import React, { useState } from 'react';
import { RefreshListIcons } from '../../../../../../../../icons/icons';
import { NameEmailAvatar } from '../../../../../../../../ui';
import { ContextMenu, MenuItemType } from '../../../../../../../../ui/components/Common/ContextMenu/ContextMenu';
import { ContextMenuButton } from '../../../../../../../../ui/components/Common/ContextMenu/ContextMenuButton';

const TooltipWrapper: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className='relative group w-full flex items-center justify-start text-left'>
      { /* Truncated Text */ }
      <div className='max-w-[180px] truncate whitespace-nowrap overflow-hidden'>
        { text || '-' }
      </div>

      { /* Tooltip */ }
      <div className='absolute z-[9999] hidden group-hover:flex flex-col items-center'>
        <div className='relative'>
          { /* Tooltip Box */ }
          <div className='absolute bottom-full  px-3 py-2 text-sm text-white bg-gray-900 rounded-md shadow-lg w-max max-w-xs whitespace-normal'>
            { text }
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionMenu: React.FC<{ row: any, onRetake: (row: any) => void }> = ({ row, onRetake }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const menuItems: MenuItemType<any>[] = [
    {
      label: 'Remove Invite',
      icon: <RefreshListIcons />,
      permission: [],
      onClick: () => onRetake(row),
    },
  ];

  if (!row.userAssessmentId) {
    return null;
  }

  return (
    <>
      <ContextMenuButton
          row={row}
          onOpenMenu={handleOpenMenu}
          onCloseMenu={handleCloseMenu}
          anchorEl={anchorEl}
      />
      <ContextMenu
          anchorEl={anchorEl}
          onClose={handleCloseMenu}
          row={row}
          menuItems={menuItems}
      />
    </>
  );
};

export const getColumns = (onRetake: (row: any) => void) => [
  {
    key: 'candidate',
    label: 'Candidate',
    width: '150px',
    align: 'left' as const,
    render: (row: any) => (
      <NameEmailAvatar
          email={row.email}
          name={`${row.firstName} ${row.lastName}`}
          avatar={row.base64Encoded}
      />
    ),
  },
  {
    key: 'applicantStatus',
    label: 'Status',
    width: '250px',
    align: 'left' as const,
    render: (row: any) => <TooltipWrapper text={row.applicantStatus} />,
    disableSort: false,
  },
  {
    key: 'invited',
    label: 'Invited',
    width: '250px',
    align: 'left' as const,
    render: (row: any) => (
      <TooltipWrapper text={row.invited === true ? 'YES' : 'NO'} />
    ),
    disableSort: false,
  },
  {
    key: 'assessmentStatus',
    label: 'Assessment Status',
    width: '250px',
    align: 'left' as const,
    render: (row: any) => <TooltipWrapper text={row.assessmentStatus} />,
    disableSort: false,
  },
  {
    key: 'actions',
    label: '',
    width: '50px',
    align: 'right' as const,
    render: (row: any) => <ActionMenu row={row} onRetake={onRetake} />,
    disableSort: true,
  },
];
